// extracted by mini-css-extract-plugin
export default {"page_wrap":"CandidatePage_page_wrap__misK4"};